module.exports = __webpack_public_path__ + "img/source3_13.ba829d29.png";